// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
	return {
		MuiInputLabel: {
			styleOverrides: {
				root: {},
				filled: {
					padding: 10,
					WebkitTextFillColor: theme.palette.primary[800],
					'&.MuiInputLabel-shrink': {
						WebkitTextFillColor: theme.palette.primary[800],
						padding: 0
					},
				}
			}
		}
	}
}
